import { create } from 'zustand';
export const useFullyReadMarkerStore = create((set) => ({
    counts: {},
    markers: {},
    setState: (fn) => {
        set((state) => fn(state));
    },
}));
//# sourceMappingURL=use-fully-read-marker-store.js.map